'use client';

import { Box, Skeleton } from '@mui/material';

export const BottomNavigationSkeleton = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        display: { xs: 'flex', md: 'none' },
        height: 64,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        width: '100%',
        maxWidth: '100vw',
        px: 2,
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      {[...Array(4)].map((_, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            flex: 1,
          }}
        >
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="rectangular" width={40} height={10} sx={{ borderRadius: '4px' }} />
        </Box>
      ))}
    </Box>
  );
};
